import Header from "../../Containers/Header/Header";
import React, { Component } from "react";
import { connect } from "react-redux";
import * as StoreActions from "../../ReduxStore/Actions/ActionIndex";
import Aux from "../AUXX/Auxx";
import FullscreenLoader from "../../Components/UI/FullscreenLoader/FullscreenLoader";
import LiveEventList from "../../Containers/LiveEventList/LiveEventList";
import RightSectionTicket from "../../Containers/RightSectionTicket/RightSectionTicket";
import CssClasses from "./LayoutLive.css";
import * as LocalStorageKeys from "../../HOCs/Constants/LocalStorageKeys";
//import RegularKeyboard from "../../Components/Keyboards/RegularKeyboard/RegularKeyboard";
import AdditionalBets from "../../Components/AdditionalBets/AdditionalBets";
import InfoContainer from "../../Components/InfoContainer/InfoContainer";
//import TicketDisplay from "../../Components/TicketDisplay/TicketDisplay";
import TicketPreview from "../../Components/TicketPreview/TicketPreview";
import PartialPayoutPopup from "../../Components/PartialPayoutPopup/PartialPayoutPopup";
import SystemCombinationsPopup from "../../Components/SystemCombinationsPopup/SystemCombinationsPopup";
import FullscreenModalPopup from "../../Components/UI/FullscreenModalPopup/FullscreenModalPopup";
import AdminLogin from "../../Components/AdminLogin/AdminLogin";

import Auxx from "../AUXX/Auxx";
import * as ZebraErrorCodes from "../../HOCs/Constants/ZebraErrorCodes";
import * as UserPermissionIDs from "../../HOCs/Constants/UserPermissionIDs";

import {
  SelectTicket,
  SelectTicketPairs
} from "../../Communication/TicketServicesHandler";

import { SelectPayoutRequest } from "../../Communication/PartialPayoutServicesHandler";
import { LoginUserByToken } from "../../Communication/OtherServicesHandler";

import CefMonitor from "../CefMonitor/CefMonitor";

class LayoutLive extends Component {
  ADMIN_QR_ACTION_LOGIN = 1;
  ADMIN_QR_ACTION_OPEN_DRAWER = 2;
  ADMIN_QR_ACTION_RESTART = 3;
  ADMIN_QR_ACTION_SHUTDOWN = 4;

  ticketInfo = {};
  payoutReceiptInfo = {};

  timerRef = null;

  currentText = "";

  state = {
    infoMessage: null,
    ticketNumber: 0,
    isShowingAdminLogin: false,
    lastAdminQRAction: 0
  };

  keyDownListener = e => {
    this.keyDownTextField(e);
  };

  componentWillMount() {
    //pretplati se na promjenu
    window.addEventListener("storage", this.storageHandler, false);
    document.addEventListener("keydown", this.keyDownListener, false);
    this.currentText = "";

    console.log("DOCUMENT IS ", document);

    //console.log("THE CALLBACK IS " + this.selectTicket_Callback);
  }

  componentWillUnmount() {
    window.removeEventListener("storage", this.storageHandler, false);
    document.removeEventListener("keydown", this.keyDownListener, false);
  }

  componentDidMount() {
    //rucno
    //SelectTicket("999888777001807", this.selectTicket_Callback);

    // setTimeout(() => {
    //   //SelectTicket(999888777002234, "25U", this.selectTicket_Callback);
    //   SelectTicket(999888777002225, "CLI", this.selectTicket_Callback);
    // }, 2000);

    //auto baci na admin
    // setTimeout(() => {
    //   this.processAdminAction(
    //     this.ADMIN_QR_ACTION_LOGIN,
    //     "ADMIN-CMD-LOGIN-815970E7-8187-4BB2-BC88-F795C3FB878E"
    //   );
    // }, 2500);

    //podesi timer
    window.onload = this.resetTimer.bind(this);
    window.onmousemove = this.resetTimer.bind(this);
    window.onmousedown = this.resetTimer.bind(this); // catches touchscreen presses as well
    window.ontouchstart = this.resetTimer.bind(this); // catches touchscreen swipes as well
    window.ontouchmove = this.resetTimer.bind(this);
    window.onclick = this.resetTimer.bind(this); // catches touchpad clicks as well
    window.onkeypress = this.resetTimer.bind(this);
    window.addEventListener("scroll", this.resetTimer.bind(this), true); // improved; see comments
  }

  resetTheApp() {
    console.log("APP RESET!");

    //pocisti parove
    this.props.onRemoveAllPairs();

    //oznaci prvi sport koji ima
    //filtriraj po listi
    let activeInfo = this.props.livePickerInfo;

    if (activeInfo !== null && activeInfo.length > 0) {
      //sortiraj
      activeInfo.sort((a, b) => {
        return a.UIOrderIndex - b.UIOrderIndex;
      });

      //oznaci prvoga i gasi live
      this.props.setShouldQuickCloseExtraBets(true);
      this.props.setIsShowingBonusInfo(false);
      this.props.onSetLiveExtraBetsID(-1);
      this.props.setCanShowExtraLiveBets(true);
      this.props.onChangeSportLive(activeInfo[0].sportID);

      setTimeout(() => {
        this.props.setShouldQuickCloseExtraBets(false);
      }, 100);
    }
  }

  resetTimer() {
    clearTimeout(this.timerRef);
    this.timerRef = setTimeout(
      function() {
        this.resetTheApp();
      }.bind(this),
      300000
    );
    // 1000 milliseconds = 1 second

    //javi kroz storage
    localStorage.setItem(
      LocalStorageKeys.LOCALSTORAGE_LAST_USER_INTERACTION,
      JSON.stringify({ src: "live", time: new Date() })
    );
  }

  resetTimerForSelf() {
    clearTimeout(this.timerRef);
    this.timerRef = setTimeout(
      function() {
        this.resetTheApp();
      }.bind(this),
      300000
    );
  }

  keyDownTextField(e) {
    console.log("TMP INPUT IS: " + this.currentText);
    console.log("CURRENT TEXT IS ", this.currentText);

    var keyCode = e.keyCode;
    if (keyCode === 13) {
      //enter
      this.currentText = this.currentText.replace("undefined", "");
      console.log("---> FULL INPUT IS: " + this.currentText);
      //window.cefCustomObject.processKeyboardInput(this.currentText);

      var query = this.currentText;
      this.currentText = "";

      this.processQRQuery(query);
    } else {
      if (
        e.key !== "Shift" &&
        e.key !== "undefined" &&
        e.key !== undefined &&
        e.key !== "NumLock" &&
        e.key !== "ArrowDown"
      ) {
        //this.currentText = "KURCINA";
        this.currentText += e.key;

        //pali loading odmah!
        this.props.startLoading(false, true);

        //i gasi trenutni tiket i payout receipt
        this.props.setTicketNumberForDetails(0);
        this.props.setPayoutReceiptNumber(0);
      }
    }
  }

  processQRQuery = query => {
    //pali loading odmah!
    this.props.startLoading(false, true);

    //i gasi trenutni tiket i payout receipt
    this.props.setTicketNumberForDetails(0);
    this.props.setPayoutReceiptNumber(0);

    console.log("QUERY IS: " + query);
    console.log("THIS IS ", this);
    console.log("THIS STATE IS ", this.state);

    //gasi info message ako ga ima
    this.setState({ infoMessage: "" });

    if (query.indexOf("CHECK-TICKET") !== -1) {
      //odijeli brojeve
      let ticketNo = query.split("-")[2];
      let ticketCode = query.split("-")[3];

      //kesiraj si ga
      this.setState({ ticketNumber: ticketNo });

      //alert("CHECKING TICKET");
      //pokreni dohvat tiketa
      SelectTicket(ticketNo, ticketCode, this.selectTicket_Callback);
    } else if (query.indexOf("CHECK-PARTIAL-VOUCHER") !== -1) {
      //odijeli brojeve
      let ticketNo = query.split("-")[3];
      let securityCode = query.split("-")[4];

      //kesiraj si ga
      this.setState({ ticketNumber: ticketNo });

      //alert("CHECKING TICKET");
      //pokreni dohvat tiketa
      SelectPayoutRequest(
        ticketNo,
        securityCode,
        this.selectPayoutRequest_Callback.bind(this)
      );
    } else if (query.indexOf("ADMIN-CMD-SHUTDOWN") !== -1) {
      this.processAdminAction(this.ADMIN_QR_ACTION_SHUTDOWN, query);
    } else if (query.indexOf("ADMIN-CMD-RESTART") !== -1) {
      //gasi
      this.processAdminAction(this.ADMIN_QR_ACTION_RESTART, query);
    } else if (query.indexOf("ADMIN-CMD-LOGIN") !== -1) {
      //gasi
      //window.cefCustomObject.loginAdmin();
      this.processAdminAction(this.ADMIN_QR_ACTION_LOGIN, query);
    } else if (query.indexOf("ADMIN-CMD-OPENDRAWER") !== -1) {
      //gasi
      this.processAdminAction(this.ADMIN_QR_ACTION_OPEN_DRAWER, query);
    } else {
      this.props.stopLoading(true);
      this.setState({ infoMessage: "Nepoznat QR kod! Vrijednost: " + query });
    }
  };

  processAdminAction = (actionID, query) => {
    //spremi ju u state
    this.setState({ lastAdminQRAction: actionID });

    console.log("aid query " + actionID + " " + query);

    //dohvati usertoken
    var vals = query.split("-");

    if (vals.length < 4) {
      //nemore!
      this.setState({ infoMessage: "Neispravan QR kod!" });
      return;
    }

    //komande su u formatu admin-cmd-xxxxxxx-GUID
    //ignore idx 0 1 2
    var token = "";
    for (let i = 3; i < vals.length; i++) {
      const el = vals[i];
      token += el;

      if (i !== vals.length - 1) {
        token += "-";
      }
    }

    //zovi servis
    LoginUserByToken(
      this.props.machineInfo.MachineGUID,
      token,
      this.loginUserByToken_Callback.bind(this)
    );
  };

  loginUserByToken_Callback = val => {
    this.props.stopLoading(true);

    if (!val || val === "") {
      //nema, krivo!
      this.setState({
        infoMessage: "Nemate autorizaciju na ovom terminalu!"
      });
      return;
    }

    console.log("USERIC JE ", val);
    console.log("LAST ACTION IS ", this.state.lastAdminQRAction);

    //radi sto je trebalo
    switch (this.state.lastAdminQRAction) {
      case this.ADMIN_QR_ACTION_LOGIN:
        if (val.PermissionList.includes(UserPermissionIDs.ADMIN_ACTION_LOGIN)) {
          //javi da je trenutno admin prijavljen
          window.cefCustomObject.changeAdminLoginState(true);
          this.props.setAdminInfo(val);
        } else {
          this.setState({
            infoMessage: "Ukinuta vam je dozvola za prijavu na ovaj terminal!"
          });
        }
        break;
      case this.ADMIN_QR_ACTION_SHUTDOWN:
        //samo ako smije
        if (
          val.PermissionList.includes(UserPermissionIDs.ADMIN_ACTION_SHUT_DOWN)
        ) {
          window.cefCustomObject.shutDown();
        } else {
          this.setState({
            infoMessage: "Nemate autorizaciju za tu radnju na ovom terminalu!"
          });
        }
        break;
      case this.ADMIN_QR_ACTION_RESTART:
        if (
          val.PermissionList.includes(UserPermissionIDs.ADMIN_ACTION_RESTART)
        ) {
          window.cefCustomObject.restart();
        } else {
          this.setState({
            infoMessage: "Nemate autorizaciju za tu radnju na ovom terminalu!"
          });
        }
        break;
      case this.ADMIN_QR_ACTION_OPEN_DRAWER:
        if (
          val.PermissionList.includes(
            UserPermissionIDs.ADMIN_ACTION_OPEN_DRAWER
          )
        ) {
          this.setState({ infoMessage: "Coming soon!" });
        } else {
          this.setState({
            infoMessage: "Nemate autorizaciju za tu radnju na ovom terminalu!"
          });
        }
        break;
      default:
        break;
    }
  };

  selectPayoutRequest_Callback = val => {
    console.log("THIS IS CALLBACK ", val);

    //provjeri da postoji
    if (val === null || val === "?") {
      //pali loading odmah!
      this.props.stopLoading(true);

      var msg = (
        <p>
          Potvrda s brojem {this.state.ticketNumber} nije pronađena! <br />
          <br />
          Provjerite da ste ispravno unijeli broj potvrde i sigurnosni kod.
        </p>
      );

      setTimeout(() => {
        this.setState({
          infoMessage: msg
        });
      }, 50);

      return;
    }

    //vidi je bila greska
    if (val === -500) {
      //pali loading odmah!
      this.props.stopLoading(true);

      setTimeout(() => {
        this.setState({ infoMessage: "Greška prilikom dohvata potvrde!" });
      }, 50);

      return;
    }

    //kesiraj
    this.payoutReceiptInfo = val;

    //alert("NUM IS " + val.ReceiptNumber);
    this.props.stopLoading(true);
    //i upisi u props
    this.props.setPayoutReceiptNumber(val.ReceiptNumber);
  };

  selectTicket_Callback = val => {
    console.log("THIS IS CALLBACK ", val);
    //alert("DOBITAK TIKETA JE " + val.WinAmount);

    //provjeri da postoji
    if (val === null || val === "?") {
      //gasi loading odmah!
      this.props.stopLoading(true);

      setTimeout(() => {
        var msg = (
          <p>
            Listić s brojem {this.state.ticketNumber} nije pronađen! <br />
            <br />
            Provjerite da ste ispravno unijeli broj listića i sigurnosni kod.
          </p>
        );

        this.setState({
          infoMessage: msg
        });
      }, 50);

      return;
    }

    //vidi je bila greska
    if (val === -500) {
      //pali loading odmah!
      this.props.stopLoading(true);

      setTimeout(() => {
        this.setState({ infoMessage: "Greška prilikom dohvata listića!" });
      }, 50);

      return;
    }

    //kesiraj i vozi dalje
    this.ticketInfo.generalInfo = val;

    //dohvati parove po id-u
    SelectTicketPairs(val.IDSportTicket, this.selectTicketPairs_Callback);
  };

  selectTicketPairs_Callback = val => {
    console.log("THIS IS CALLBACK ", val);
    //alert("DOBITAK TIKETA JE " + val.WinAmount);

    if (val === null || val.length === 0 || val === -500) {
      //nema parova
      this.props.stopLoading(true);

      setTimeout(() => {
        this.setState({
          infoMessage: "Greška prilikom dohvata parova tiketa!"
        });
      }, 50);

      return;
    }

    //prekini loading
    this.props.stopLoading(true);

    //pisi
    this.ticketInfo.pairs = val;

    //logiraj
    console.log("RECEIVED TICKET ", this.ticketInfo);

    this.props.setTicketNumberForDetails(
      this.ticketInfo.generalInfo.TicketNumber
    );
  };

  componentWillUpdate() {
    //console.log("UPD");
  }

  storageHandler = event => {
    //alert("storage bitch live!");

    console.log("Storage event for key: ", event.key);

    if (event.key === LocalStorageKeys.LOCALSTORAGE_APPSTATE) {
      //pozovi events
      this.appStateChangedHandler();

      console.log("STORAGE EVENT ZA APPSTATE!");
    }

    if (event.key === LocalStorageKeys.LOCALSTORAGE_BALANCE) {
      //pozovi event
      this.balanceStateChangedHandler();
    }

    if (event.key === LocalStorageKeys.LOCALSTORAGE_LAST_USER_INTERACTION) {
      //pozovi event
      this.resetTimerForSelf();
    }

    if (event.key === LocalStorageKeys.LOCALSTORAGE_TICKET_CHECK) {
      //pozovi event
      this.ticketCheckHandler();
    }

    if (event.key === LocalStorageKeys.LOCALSTORAGE_SHOW_ADMIN_LOGIN) {
      //pozovi event
      this.setState({ isShowingAdminLogin: true });
    }

    if (event.key === LocalStorageKeys.LOCALSTORAGE_QR_INPUT) {
      //dohvati query
      //dohvati iz storagea
      var query = localStorage.getItem(LocalStorageKeys.LOCALSTORAGE_QR_INPUT);

      //pozovi event
      this.processQRQuery(query);
    }

    if (event.key === LocalStorageKeys.K_LOCAL_STORAGE_KEY_MACHINE_INFO) {
      //dohvati iz storagea
      var config = localStorage.getItem(
        LocalStorageKeys.K_LOCAL_STORAGE_KEY_MACHINE_INFO
      );

      //pozovi event
      this.processMachineConfig(config);
    }
  };

  processMachineConfig = config => {
    console.log("RECEIVED CONFIG: ", config);
    console.log("PARSED CONFIG: ", JSON.parse(config));

    this.props.setMachineConfig(config);
  };

  appStateChangedHandler = () => {
    //dohvati iz storagea
    var appState = JSON.parse(
      localStorage.getItem(LocalStorageKeys.LOCALSTORAGE_APPSTATE)
    );

    console.log("SERVERSTATUS: Received info from LocalStorage! ", appState);

    //i spremi u state
    this.props.onChangeServerStatus(appState.serverStatusCode, false);

    if (appState.isLoading === true) {
      this.props.startLoading(false, false);
    } else {
      this.props.stopLoading(false);
    }

    //alert("SORT IS " + appState.sortTypeID + " ODD IS " + appState.oddFormatID);

    this.props.changeSortType(appState.sortTypeID, false);
    this.props.changeOddFormat(appState.oddFormatID, false);
    this.props.changeLanguage(appState.currentLanguage, false);
    this.props.changeLiveTheme(appState.currentActiveLiveTheme, false);
    this.props.onChangePrinterStatuses(appState.printerStatuses, false);

    //promijeni i statuse printera
  };

  balanceStateChangedHandler = () => {
    //dohvati iz storagea
    var balance = JSON.parse(
      localStorage.getItem(LocalStorageKeys.LOCALSTORAGE_BALANCE)
    );

    console.log("SERVERSTATUS: Received info from LocalStorage! ", balance);

    //i spremi u state,
    this.props.updateBalance(balance.currentBalance, false);
  };

  ticketCheckHandler = () => {
    //gasi poruku ikakvu ako ima
    this.setState({ infoMessage: "" });

    //i gasi trenutni tiket i payout receipt
    this.props.setTicketNumberForDetails(0);
    this.props.setPayoutReceiptNumber(0);

    console.log("ticketCheckHandler");

    //dohvati iz storagea
    var info = JSON.parse(
      localStorage.getItem(LocalStorageKeys.LOCALSTORAGE_TICKET_CHECK)
    );

    console.log("Received ticket info from LocalStorage! ", info);

    if (info.type === "ticket") {
      //pali loading odmah!
      this.props.startLoading(false, true);

      //kesiraj si ga
      this.setState({ ticketNumber: info.ticketNumber });

      SelectTicket(
        info.ticketNumber,
        info.ticketCode,
        this.selectTicket_Callback
      );
    } else if (info.type === "receipt") {
      //pali loading odmah!
      this.props.startLoading(false, true);

      //kesiraj si ga
      this.setState({ ticketNumber: info.ticketNumber });

      SelectPayoutRequest(
        info.ticketNumber,
        info.ticketCode,
        this.selectPayoutRequest_Callback.bind(this)
      );
    } else {
      console.log("UNKNOWN REQUEST! ", info.type);
    }
  };

  render() {
    //console.log("LAYOUTLIVE MATCHES: ", this.props.liveMatchesList);

    //provjeri ako smo na magicwinu, id 1000
    if (this.props.currentLiveSportID === 1000) {
      setTimeout(() => {
        this.setupMagicWinWidget();
      }, 0);

      return (
        <div
          className={[
            CssClasses.mainContainer,
            this.props.currentActiveLiveTheme === 2
              ? CssClasses.lightTheme
              : " "
          ].join(" ")}
        >
          <CefMonitor />
          {this.props.isAppLoading || this.props.serverStatusCode !== 200 ? (
            <FullscreenLoader
              withTransparentBackground={this.props.isLoaderTransparent}
              errorMessage={
                this.props.serverStatusCode !== 200
                  ? "Usluga trenutno nije dostupna! Ponovno spajanje..."
                  : ""
              }
            />
          ) : null}
          {this.props.machineInfo.CurrentPaperLengthMM <
          this.props.machineInfo.MinPaperLengthMM ? (
            <FullscreenLoader
              withTransparentBackground={this.props.isLoaderTransparent}
              errorMessage={
                "Papir je pri kraju! Obratite se vlasniku objekta da zamijeni papir kako bi se uređaj mogao nastaviti koristiti."
              }
            />
          ) : null}
          {this.state.isShowingAdminLogin ? (
            <AdminLogin btnCloseClickCallback={this.closeAdminLogin} />
          ) : null}
          <Header hasMagicWin hasUserInfo />{" "}
          <div id="magicwin" style={{ zoom: "115%" }} />{" "}
        </div>
      );
    }

    //stvori klase za extrabets
    let extraBetsClasses = [CssClasses.extraBetsContainer];

    if (this.props.liveExtraBetsID > 0) {
      //dodaj show
      extraBetsClasses.push(CssClasses.showExtraBetsContainer);
    } else {
      //Dodaj hide
      extraBetsClasses.push(CssClasses.hideExtraBetsContainer);
    }

    let showsTicket = this.props.currentTicketNumber > 0;

    // console.log("ALL EBTS SU ", this.props.allBets);

    // if (this.props.allBets) {
    //   console.log(
    //     "FILTERED EBTS SU ",
    //     this.props.allBets.filter(
    //       x => x.UtakmicaID === this.props.liveExtraBetsID && x.Aktivno
    //     )
    //   );
    // }

    //nismo, returnaj nesto drugo
    return (
      <Aux>
        {/* hack da forsira update */}
        <span style={{ display: "none" }}>{this.props.updateStampOData}</span>

        <CefMonitor />
        {this.props.isAppLoading ||
        this.props.serverStatusCode !== 200 ||
        this.props.printerStatusList.includes(
          ZebraErrorCodes.ZEBRA_WARNING_PAPER_LOW
        ) ||
        this.props.printerStatusList.includes(
          ZebraErrorCodes.ZEBRA_ERROR_CUTTER_FAULT
        ) ||
        this.props.printerStatusList.includes(
          ZebraErrorCodes.ZEBRA_ERROR_HEAD_OPEN
        ) ||
        this.props.printerStatusList.includes(
          ZebraErrorCodes.ZEBRA_ERROR_MEDIA_OUT
        ) ||
        this.props.printerStatusList.includes(
          ZebraErrorCodes.ZEBRA_ERROR_RIBBON_OUT
        ) ? (
          <FullscreenLoader
            withTransparentBackground={this.props.isLoaderTransparent}
            errorMessage={
              this.props.serverStatusCode !== 200
                ? "Usluga trenutno nije dostupna! Ponovno spajanje..."
                : this.props.printerStatusList.includes(
                    ZebraErrorCodes.ZEBRA_WARNING_PAPER_LOW
                  )
                ? "Papir je pri kraju! Provjerite i zamijenite papir."
                : this.props.printerStatusList.includes(
                    ZebraErrorCodes.ZEBRA_ERROR_CUTTER_FAULT
                  )
                ? "Greška u printeru - Provjerite rezač!"
                : this.props.printerStatusList.includes(
                    ZebraErrorCodes.ZEBRA_ERROR_HEAD_OPEN
                  )
                ? "Greška u printeru - Otvorena glava pisača!"
                : this.props.printerStatusList.includes(
                    ZebraErrorCodes.ZEBRA_ERROR_MEDIA_OUT
                  )
                ? "Greška u printeru - Nema papira u vodilici!"
                : this.props.printerStatusList.includes(
                    ZebraErrorCodes.ZEBRA_ERROR_RIBBON_OUT
                  )
                ? "Greška u printeru - Provjerite ribon!"
                : ""
            }
          />
        ) : null}

        {this.props.machineInfo.CurrentPaperLengthMM <
        this.props.machineInfo.MinPaperLengthMM ? (
          <FullscreenLoader
            withTransparentBackground={this.props.isLoaderTransparent}
            errorMessage={
              "Papir je pri kraju! Obratite se vlasniku objekta da zamijeni papir kako bi se uređaj mogao nastaviti koristiti."
            }
          />
        ) : null}

        <FullscreenModalPopup
          message={this.state.infoMessage}
          btnOkClickCallback={this.modalPopupBtnOk_Callback}
        />

        {this.state.isShowingAdminLogin ? (
          <AdminLogin btnCloseClickCallback={this.closeAdminLogin} />
        ) : null}

        {/* {showsTicket ? <TicketDisplay closeEvent={this.closeTicket} /> : ""} */}
        <TicketPreview
          closeEvent={this.closeTicket}
          ticketData={this.ticketInfo}
        />

        {this.props.currentPayoutReceiptNumber > 0 ? (
          <PartialPayoutPopup payoutReceiptInfo={this.payoutReceiptInfo} />
        ) : null}

        {this.props.isShowingSystemCombinations ? (
          <SystemCombinationsPopup />
        ) : null}

        <div
          className={[
            CssClasses.mainContainer,
            this.props.currentActiveLiveTheme === 2
              ? CssClasses.lightTheme
              : " ",
            showsTicket ? CssClasses.blurred : ""
          ].join(" ")}
        >
          {/* {this.props.currentTicketNumber > 1 ? <RegularKeyboard /> : null} */}

          <Header hasMagicWin hasUserInfo />
          <div className={CssClasses.containerLeftSection}>
            <LiveEventList />
            {/* renderiraj i extra bets ako treba */}
            <AdditionalBets
              allBets={
                this.props.allBets
                  ? this.props.allBets.filter(
                      x =>
                        x.UtakmicaID === this.props.liveExtraBetsID && x.Aktivno
                    )
                  : null
              }
              allBetsText={this.props.allBetsText}
              match={
                this.props.liveMatchesList
                  ? this.props.liveMatchesList.find(
                      x => x.id === this.props.liveExtraBetsID
                    )
                  : null
              }
            />
            <InfoContainer isBonusInfo />
          </div>
          <div className={CssClasses.containerRightSection}>
            <RightSectionTicket />
            {/* <div
              style={{ width: "50px", height: "50px", background: "red" }}
              onClick={() => {
                this.setState({ showTicket: true });
                console.log("CLICK");
              }}
            >
              X
            </div> */}
          </div>
        </div>
      </Aux>
    );
  }

  closeAdminLogin = () => {
    this.setState({ isShowingAdminLogin: false });
  };

  modalPopupBtnOk_Callback = () => {
    this.setState({ infoMessage: null });
  };

  onCloseNumericKeyboard = () => {
    this.props.changeNumericKeyboardVisibility(false);
  };

  closeTicket = () => {
    this.setState({ showTicket: false });
  };

  setupMagicWinWidget() {
    console.log('"INITIALIZING MAGIC WIDGET AT ' + new Date());

    var setup = {
      container: "magicwin", //id container
      //lang: 'en', //default: en.  en||hr||sr||de||bs
      lang: "en", //default: en.  en||hr||sr||de||bs||ru
      runFrom: 2, //0 - undefind, 1 - Desktop app, 2 - desktop web, 3 - mob web, 4 - mob app
      options: {
        //MagicWin  game options,
        //  which game you will open on load widget
        game: "LuckySix", //default: LuckySix.  LuckySix||Lotto548||Lotto748||Special||Dealer||Special2||Lotto520||Lotto1020||Dealer2
        defaultCurrency: "EUR", //default: 'EUR' if user don't signed, widget will be open with default currency
        skin: 2, // default 1, 1 -white, 2 - dark
        oddCulture: 0 // odds culture:    1 - SAD, 2 - Malaysia, 3 - Indonesia, 4 - Hong Kong, 5 - England (fraction), 0 - default decimal
      },
      //test 6 EUR
      UserToken: "6C7B3ECE-35F9-403C-BA7F-59DE94C645A8",
      onLoad: function(instance) {
        console.log("Game is loaded.");
      },
      onChangeBalance: function() {
        console.log("Balance is changed"); //calling after Bet ticket, Win ticket, Tip dealer
      }
    };

    window.MagicGames.addWidget(setup);
  }
}

// const closeExtraBets = props => {
//   props.onSetLiveExtraBetsID(-1);
// };

const mapStateToProps = state => {
  return {
    isAppLoading: state.rrAppState.isLoading,
    isLoaderTransparent: state.rrAppState.isLoadingTransparent,
    currentLiveSportID: state.rrNavigation.liveSportID,
    liveExtraBetsID: state.rrNavigation.liveExtraBetsID,
    serverStatusCode: state.rrAppState.serverStatusCode,
    isShowingNumericKeyboard: state.rrAppState.isShowingNumericKeyboard,
    currentActiveLiveTheme: state.rrAppState.currentActiveLiveTheme,
    liveMatchesList: state.rrSportEvent.liveMatchesList,
    livePickerInfo: state.rrSportEvent.activeLiveSports,
    currentTicketNumber: state.rrNavigation.currentTicketNumber,
    currentPayoutReceiptNumber: state.rrNavigation.currentPayoutReceiptNumber,
    printerStatusList: state.rrAppState.printerStatuses,
    isShowingSystemCombinations: state.rrNavigation.isShowingSystemCombinations,
    allBets: state.rrSportEvent.allBets,
    allBetsText: state.rrSportEvent.allBetsText,
    updateStampOData: state.rrSportEvent.updateStampOData,
    machineInfo: state.rrAppState.machineInfo
  };
};

const mapDispatchToProps = dispatch => {
  return {
    loginAdmin: () => dispatch(StoreActions.ChangeAdminLoginState(true)),
    startLoading: (isTransparent, updateLocalStorage) =>
      dispatch(StoreActions.StartLoading(isTransparent, updateLocalStorage)),
    stopLoading: updateLocalStorage =>
      dispatch(StoreActions.StopLoading(updateLocalStorage)),
    onChangeServerStatus: (code, updateStorage) =>
      dispatch(StoreActions.ChangeServerStatus(code, updateStorage)),
    onSetLiveExtraBetsID: betsID =>
      dispatch(StoreActions.ChangeCurrentLiveExtraBetsID(betsID)),
    changeOddFormat: (oddFormat, updateStorage) =>
      dispatch(StoreActions.SetOddFormat(oddFormat, updateStorage)),
    changeSortType: (sortID, updateStorage) =>
      dispatch(StoreActions.SetSortType(sortID, updateStorage)),
    changeLiveTheme: (themeID, updateStorage) =>
      dispatch(StoreActions.SetLiveTheme(themeID, updateStorage)),
    changeLanguage: (languageCode, updateStorage) =>
      dispatch(StoreActions.SetLanguage(languageCode, updateStorage)),
    setTicketNumberForDetails: ticketNumber =>
      dispatch(StoreActions.SetTicketNumberForDetails(ticketNumber)),
    setPayoutReceiptNumber: ticketNumber =>
      dispatch(StoreActions.SetPayoutReceiptNumber(ticketNumber)),
    changeNumericKeyboardVisibility: isShown =>
      dispatch(StoreActions.SetNumericKeyboardVisibility(isShown)),
    onChangePrinterStatuses: (printerStatuses, updateStorage) =>
      dispatch(
        StoreActions.ChangePrinterStatuses(printerStatuses, updateStorage)
      ),
    updateBalance: (amountInCents, updateLocalStorage) =>
      dispatch(StoreActions.UpdateBalance(amountInCents, updateLocalStorage)),
    setMachineConfig: config => dispatch(StoreActions.SetMachineInfo(config)),
    onRemoveAllPairs: () => dispatch(StoreActions.RemoveAllPairs()),
    onChangeSportLive: sportID =>
      dispatch(StoreActions.ChangeSportLive(sportID)),
    setShouldQuickCloseExtraBets: shouldClose =>
      dispatch(StoreActions.SetShouldQuickCloseExtraBets(shouldClose)),
    setCanShowExtraLiveBets: canShow =>
      dispatch(StoreActions.SetCanShowExtraLiveBets(canShow)),
    setIsShowingBonusInfo: isShown =>
      dispatch(StoreActions.SetIsShowingBonusInfo(isShown)),
    setAdminInfo: userInfo => dispatch(StoreActions.SetAdminInfo(userInfo))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LayoutLive);



// WEBPACK FOOTER //
// ./src/HOCs/LayoutLive/LayoutLive.js